// One editor session; never reuse authenticated media across users or dialogs.
function createThumbnailCache(limit = 128, byteLimit = 24 * 1024 * 1024) {
  const entries = new Map()
  let disposed = false, bytes = 0
  function remove(key, entry) {
    entries.delete(key); entry.controller.abort()
    if (entry.url) { URL.revokeObjectURL(entry.url); bytes -= entry.size }
  }
  function trim() {
    for (const [key, entry] of entries) {
      if (entries.size <= limit && bytes <= byteLimit) break
      if (!entry.refs && entry.url) remove(key, entry)
    }
  }
  return {
    peek: key => entries.get(key)?.url || '',
    acquire(key, fetch) {
      let entry = entries.get(key)
      if (!entry) {
        entry = { refs: 0, controller: new AbortController(), url: '', size: 0 }
        entries.set(key, entry)
        entry.promise = Promise.resolve().then(() => {
          if (disposed) throw new Error('Thumbnail cache closed')
          return fetch(entry.controller.signal)
        }).then(blob => {
          if (disposed) throw new Error('Thumbnail cache closed')
          entry.url = URL.createObjectURL(blob); entry.size = blob.size; bytes += blob.size; trim(); return entry.url
        }).catch(error => { if (entries.get(key) === entry) entries.delete(key); throw error })
      } else { entries.delete(key); entries.set(key, entry) }
      entry.refs++
      let released = false
      return { promise: entry.promise, release() { if (!released) { released = true; entry.refs--; trim() } } }
    },
    clear() { disposed = true; for (const [key, entry] of entries) remove(key, entry) }
  }
}
module.exports = { createThumbnailCache }
